import { useEffect, useState, useCallback } from "react";

import './App.css';
import * as Postmonger from 'postmonger';

// For testing
// window.payload = {
//   arguments: {
//     execute: {
//       inArguments: [{
//         rutCliente: '{{Contact.Attribute.Generar_Cupones_Push_Cumpleanos.RutCliente}}',
//         isRutClienteValid: true
//       }]
//     }
//   }
// }

const INPUT_CLASS_NAME = `
  rounded border-[1px] border-gray-300 w-full
  outline-0 px-4 h-10 transition duration-200
  invalid:border-red-600
  invalid:focus:border-red-600 invalid:focus:shadow-red-700/50
  focus:border-sky-500 focus:shadow-md focus:shadow-sky-600/50 
`;

function App() {
  const [connection, ] = useState(new Postmonger.Session());
  const [eventDefinitionKey, setEventDefinitionKey] = useState('');
  const [isRendered, setIsRendered] = useState(false);
  const [idType, setIdType] = useState('IdUsuarioAppCopec'); // picklist
  const [idUsuario, setIdUsuario] = useState({ value:'', error:'' }); // idUsuarioAppCopec
  const [rutCliente, setRutCliente] = useState({value:'',error:''});
  const [idCupon, setIdCupon] = useState({value:'',error:''});
  const [waitEventDefinitionKey, setWaitEventDefinitionKey] = useState({value:'',error:''});
  const [aliado, setAliado] = useState({ value: '', error: '' });
  const [deFields, setDeFields] = useState([]);


  console.log(eventDefinitionKey);

  // Auxiliar para setear los campos del formulario
  const setFormFields = useCallback((inArguments) => {
    setIdType(inArguments.idType || 'IdUsuarioAppCopec');
    setRutCliente({
      value: inArguments.rutCliente,
      error: inArguments.isRutClienteValid ? 'hidden' : ''
    });
    setIdCupon({
      value: inArguments.idCupon,
      error: inArguments.isIdCuponValid ? 'hidden' : ''
    });
    setWaitEventDefinitionKey({
      value: inArguments.waitEventDefinitionKey,
      error: inArguments.isWaitEventDefinitionKeyValid ? 'hidden' : ''
    });
    setAliado({
      value: inArguments.aliado,
      error: inArguments.isAliadoValid ? 'hidden' : ''
    });
    setIdUsuario({
      value: extractFieldKey(inArguments.idUsuario),
      error: inArguments.isIdUsuarioValid ? 'hidden' : ''
    });
  }, []);

  function extractFieldKey(templateString) {
    if (!templateString) return '';
    const open = templateString.indexOf('{{');
    const close = templateString.indexOf('}}');
    if (open !== -1 && close !== -1 && close > open) {
      // Extrae el contenido entre {{ y }}
      return templateString.substring(open + 2, close).trim();
    }
    // Si no tiene llaves, retorna el string original
    return templateString;
  }

  // Inicialización del activity
  const initialize = useCallback((data) => {
    console.log('*** initialize ***');
    try {
      if (!data) throw new Error('Custom activity sin config.json');
      window.payload = { ...data };
      const inArguments = data?.arguments?.execute?.inArguments ?? [];
      if (inArguments.length > 0) setFormFields(inArguments[0]);
      console.log('*payload:', data);
    } catch (error) {
      console.log('*** initialize Error***');
      console.log(error);
    }
  }, [setFormFields]);

  // Validación
  const validateData = useCallback(() => {
    const payload = { ...window.payload };
    const args = payload.arguments.execute.inArguments[0];
    let valid = args?.isIdCuponValid && args?.isWaitEventDefinitionKeyValid && args?.isAliadoValid;
    console.log('*validatepayload:',payload);
    console.log('*Tipo:',args.idType);
    if (args.idType === "IdUsuarioAppCopec") {
      console.log('*Tipo1:',args?.isIdUsuarioValid);
      valid = valid && args?.isIdUsuarioValid;
    } else if (args.idType === "PersonContactId") {
      console.log('*Tipo2:',args?.isRutClienteValid);
      valid = valid && args?.isRutClienteValid;
    }
    
    return { valid, payload };
  }, []);

  // Handler para el botón Next
  const onClickedNext = useCallback(() => {
    console.log('*** onClickedNext ***');
    try {
      const { valid, payload } = validateData();
      console.info('Is form valid:', valid);
      if (!valid) return;

      // Limpia el payload: solo deja el campo relevante
      const inArgs = payload.arguments.execute.inArguments[0];
      if (inArgs.idType === "IdUsuarioAppCopec") {
        delete inArgs.rutCliente;
        delete inArgs.isRutClienteValid;
      } else if (inArgs.idType === "PersonContactId") {
        delete inArgs.idUsuario;
        delete inArgs.isIdUsuarioValid;
      }

      payload.metaData.isConfigured = true;
      connection.trigger('updateActivity', payload);
    } catch (error) {
      console.log('*** onClickedNext Error***');
      console.log(error);
    }
  }, [validateData, connection]);

  const requestedTriggerEventDefinition = useCallback((eventDefinitionModel) => {
    console.log('*** requestedTriggerEventDefinition ***');
    try {
      setEventDefinitionKey(eventDefinitionModel.eventDefinitionKey);
      console.log('eventDefinitionModel: '+JSON.stringify(eventDefinitionModel));
      // Extrae los campos mapeados del Entry Event
      // eventDefinitionModel.data.fields es el array de campos disponibles
      
    } catch (error) {
      console.log('*** requestedTriggerEventDefinition Error***');
      console.log(error);
    }
  }, []);

  const getRequestSchema = useCallback((data) => {
    console.log('*** RequestSchema ***');
    try {
      console.log('*dataSchema:', data);
      setDeFields(data.schema);      
    } catch (error) {
      console.log('*** RequestSchema Error***');
      console.log(error);
    }
  }, []);

  // useEffect principal
  useEffect(() => {
    if (isRendered) return;

    connection.on('initActivity', initialize);
    connection.on('clickedNext', onClickedNext);
    connection.on('requestedTriggerEventDefinition', requestedTriggerEventDefinition);
    connection.trigger('requestTriggerEventDefinition');
    connection.on('requestedSchema', getRequestSchema);
    connection.trigger('requestSchema');
    connection.trigger('ready');
    setIsRendered(true);
  }, [
    connection,
    isRendered,
    initialize,
    onClickedNext,
    requestedTriggerEventDefinition,
    getRequestSchema
  ]);

  const handleChangeIdType = ({ target }) => {
    const value = target.value;
    setIdType(value);
  
    // Actualiza el payload
    const newPayload = { ...window.payload };
    newPayload.arguments.execute.inArguments[0].idType = value;

    // Limpia el campo no seleccionado
    if (value === "IdUsuarioAppCopec") {
      newPayload.arguments.execute.inArguments[0].rutCliente = '';
      newPayload.arguments.execute.inArguments[0].isRutClienteValid = false;
    } else if (value === "PersonContactId") {
      newPayload.arguments.execute.inArguments[0].idUsuario = '';
      newPayload.arguments.execute.inArguments[0].isIdUsuarioValid = false;
    }

    window.payload = {...newPayload};
  }

  const handleChangeRutCliente = ({ target }) => {
    let value = target.value;
    const error = value ? 'hidden' : '';
    // Si el tipo es PersonContactId, el valor real es RutCliente__c
    if (idType === "PersonContactId") {
      value = "{{Contact.Attribute.MaestroDeClientes.RutCliente__c}}";
    }
    setRutCliente({ value: target.value, error }); // El valor visual
    const newPayload = { ...window.payload };
    newPayload.arguments.execute.inArguments[0].rutCliente = value; // El valor real
    newPayload.arguments.execute.inArguments[0].isRutClienteValid = !!value;
    // Limpia el otro campo
    newPayload.arguments.execute.inArguments[0].idUsuario = '';
    newPayload.arguments.execute.inArguments[0].isIdUsuarioValid = false;
    window.payload = {...newPayload};
  };  
  
  const handleChangeCupon = ({target}) => {
    const newPayload = {...window.payload};
    const value = target.value;
    const error = target.checkValidity() ? 'hidden' : '';
    setIdCupon({value, error});
    newPayload.arguments.execute.inArguments[0].idCupon = value.replace(' ','').trim();
    newPayload.arguments.execute.inArguments[0].isIdCuponValid = target.checkValidity();
    window.payload = {...newPayload};
  }

  const handleChangeWaitEventDefinitionKey = ({target}) => {
    const newPayload = {...window.payload};
    const value = target.value;
    const error = target.checkValidity() ? 'hidden' : '';
    setWaitEventDefinitionKey({value, error});
    newPayload.arguments.execute.inArguments[0].waitEventDefinitionKey = value.replace(' ','').trim();
    newPayload.arguments.execute.inArguments[0].isWaitEventDefinitionKeyValid = target.checkValidity();
    window.payload = {...newPayload};
  }

  const handleChangeAliado = ({ target }) => {
    const newPayload = { ...window.payload };
    const value = target.value;
    const error = value ? 'hidden' : '';
    setAliado({ value, error });
    newPayload.arguments.execute.inArguments[0].aliado = value;
    newPayload.arguments.execute.inArguments[0].isAliadoValid = !!value;
    window.payload = {...newPayload };
  } 

  return (
    <div className="bg-white p-4 w-full">
      <form className="flex flex-col gap-6">

        {/* Picklist de tipo de identificador */}
        <div>
          <label htmlFor="idType" className="flex flex-col gap-1">
            <span className="text-sm text-gray-600"><span className="text-red-500">*</span> Tipo de Identificador:</span>
            <select
              id="idType"
              name="idType"
              value={idType}
              onChange={handleChangeIdType}
              required
              className={INPUT_CLASS_NAME}
            >
              <option value="IdUsuarioAppCopec">IdUsuarioAppCopec</option>
              <option value="PersonContactId">PersonContactId</option>
            </select>
          </label>
        </div>

        {/* Si selecciona IdUsuarioAppCopec */}
        {idType === "IdUsuarioAppCopec" && (
            <div>
            <label htmlFor="idUsuario" className="flex flex-col gap-1">
              <span className="text-sm text-gray-600"><span className="text-red-500">*</span> Selecciona el campo IdUsuarioAppCopec:</span>
              <select
                id="idUsuario"
                name="idUsuario"
                value={idUsuario.value}
                onChange={e => {
                  const value = e.target.value;
                  const error = value ? 'hidden' : '';
                  setIdUsuario({ value: value, error: error });
                  // Actualiza el payload si lo necesitas
                  const newPayload = { ...window.payload };
                  newPayload.arguments.execute.inArguments[0].idUsuario = `{{${value}}}`;
                  newPayload.arguments.execute.inArguments[0].isIdUsuarioValid = !!value;
                  // Limpia el otro campo
                  newPayload.arguments.execute.inArguments[0].rutCliente = '';
                  newPayload.arguments.execute.inArguments[0].isRutClienteValid = false;
                  window.payload = {...newPayload};
                }}
                required
                className={INPUT_CLASS_NAME}
              >
                <option value="">-- Selecciona un campo --</option>
                {deFields.map((field) => (
                  <option key={field.key} value={field.key}>
                    {field.key} {field.name ? `(${field.name})` : ''}
                  </option>
                ))}
              </select>
            </label>
            <div className={`${idUsuario?.error} text-sm text-red-600 transition-all`}>Seleccione un campo válido</div>
          </div>
        )}

        {/* Si selecciona PersonContactId */}
        {idType === "PersonContactId" && (
          <div>
            <label htmlFor="rutCliente" className="flex flex-col gap-1">
              <span className="text-sm text-gray-600"><span className="text-red-500">*</span> Referencia PersonContactId:</span>
              <input
                id="rutCliente"
                type="text"
                name="rutCliente"
                onChange={handleChangeRutCliente}
                value={rutCliente.value}
                required
                className={INPUT_CLASS_NAME}
                placeholder="{{Contact.Attribute.MaestroDeClientes.PersonContactId}}"
              />
            </label>
            <div className="text-xs text-gray-500">El valor real enviado será RutCliente__c.</div>
            <div className={`${rutCliente?.error} text-sm text-red-600 transition-all`}>Ingrese una referencia válida</div>
          </div>
        )}
        <div className="relative">
          <label htmlFor="idCupon" className="flex flex-col gap-1">
            <span className="text-sm text-gray-600"><span className="text-red-500">*</span> Id del cupón:</span>
            <input
              id="idCupon"
              name="idCupon"
              type="text"
              onChange={handleChangeCupon}
              value={idCupon?.value}
              maxLength={40}
              pattern="\w{40,40}"
              required
              className={INPUT_CLASS_NAME}
            />
          </label>
          <div className={`${idCupon?.error} text-sm text-red-600 transition-all`}>Ingrese un cupón válido</div>
        </div>
        <div className="relative">
          <label htmlFor="waitEventDefinitionKey" className="flex flex-col gap-1">
            <span className="text-sm text-gray-600"><span className="text-red-500">*</span> Event Definition Key (Wait Until Event):</span>
            <input
              id="waitEventDefinitionKey"
              name="waitEventDefinitionKey"
              type="text"
              onChange={handleChangeWaitEventDefinitionKey}
              value={waitEventDefinitionKey?.value}
              pattern="APIEvent-[\w\-]{36,}"
              required
              className={INPUT_CLASS_NAME}
            />
          </label>
          <div className={`${waitEventDefinitionKey?.error} text-sm text-red-600 transition-all`}>Ingrese un APIEvent válido (Ej: APIEvent-134748ac-f4df-a85c-d3b6-b870899c87b3)</div>
        </div>
        {/* Campo Aliado */}
        <div className="relative">
          <label htmlFor="aliado" className="flex flex-col gap-1">
            <span className="text-sm text-gray-600"><span className="text-red-500">*</span> Aliado:</span>
            <select
              id="aliado"
              name="aliado"
              value={aliado.value}
              onChange={handleChangeAliado}
              required
              className={INPUT_CLASS_NAME}
            >
              <option value="">Seleccione un aliado</option>
              <option value="general">General</option>
              <option value="nrt">NRT</option>
            </select>
          </label>
          <div className={`${aliado?.error} text-sm text-red-600 transition-all`}>Seleccione un aliado</div>
        </div>
      </form>
    </div>
  );
}

export default App;